// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.about-page[data-v-d0f1e35c] {
  width: min(1280px, calc(100vw - 28px));
  margin: 0 auto;
  padding: 28px 0 56px;
  color: #f7f1e8;
}
.about-hero[data-v-d0f1e35c],
.about-card[data-v-d0f1e35c],
.about-links-card[data-v-d0f1e35c],
.disabled-showcase[data-v-d0f1e35c],
.about-footer-card[data-v-d0f1e35c] {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 32px;
  background:
    radial-gradient(circle at top left, rgba(255, 240, 0, 0.12), transparent 24%),
    linear-gradient(150deg, rgba(24, 18, 10, 0.96), rgba(10, 11, 16, 0.96));
  box-shadow:
    0 24px 60px rgba(0, 0, 0, 0.36),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
}
.about-hero[data-v-d0f1e35c] {
  padding: 34px 32px;
}
.about-kicker[data-v-d0f1e35c],
.about-label[data-v-d0f1e35c] {
  margin: 0 0 10px;
  color: #fff000;
  font-size: 12px;
  letter-spacing: 4px;
  text-transform: uppercase;
}
.about-title[data-v-d0f1e35c] {
  margin: 0;
  font-size: clamp(48px, 10vw, 96px);
  line-height: 0.92;
  color: #fffdf7;
}
.about-lead[data-v-d0f1e35c],
.about-copy[data-v-d0f1e35c] {
  margin: 14px 0 0;
  max-width: 860px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 19px;
  line-height: 1.7;
}
.about-grid[data-v-d0f1e35c] {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  margin-top: 18px;
}
.about-card[data-v-d0f1e35c],
.about-links-card[data-v-d0f1e35c],
.disabled-showcase[data-v-d0f1e35c],
.about-footer-card[data-v-d0f1e35c] {
  padding: 28px;
}
.about-card-title[data-v-d0f1e35c] {
  margin: 0;
  color: #fff;
  font-size: clamp(28px, 4vw, 44px);
}
.stack-list[data-v-d0f1e35c] {
  display: grid;
  gap: 18px;
  margin-top: 18px;
}
.stack-item[data-v-d0f1e35c] {
  padding: 18px 20px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
}
.stack-item h3[data-v-d0f1e35c] {
  margin: 0;
  color: #fffdf8;
  font-size: 24px;
  line-height: 1.2;
}
.stack-item .about-copy[data-v-d0f1e35c] {
  margin-top: 10px;
}
.stack-aside[data-v-d0f1e35c] {
  margin: 10px 0 0;
  color: rgba(255, 240, 0, 0.82);
  font-size: 15px;
  line-height: 1.7;
}
.about-pills[data-v-d0f1e35c] {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 18px;
}
.about-pills span[data-v-d0f1e35c] {
  padding: 10px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  color: #f6f1e8;
  font-size: 14px;
}
.disabled-showcase[data-v-d0f1e35c] {
  margin-top: 18px;
}
.about-links-card[data-v-d0f1e35c] {
  margin-top: 18px;
}
.showcase-head[data-v-d0f1e35c] {
  margin-bottom: 18px;
}
.link-grid[data-v-d0f1e35c] {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.link-card[data-v-d0f1e35c] {
  min-height: 180px;
  padding: 22px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}
.link-card[data-v-d0f1e35c]:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 240, 0, 0.24);
  background:
    linear-gradient(180deg, rgba(255, 240, 0, 0.08), rgba(255, 255, 255, 0.03));
}
.link-label[data-v-d0f1e35c],
.link-url[data-v-d0f1e35c],
.link-copy[data-v-d0f1e35c] {
  margin: 0;
}
.link-label[data-v-d0f1e35c] {
  color: #fff;
  font-size: 22px;
  line-height: 1.4;
}
.link-url[data-v-d0f1e35c] {
  margin-top: 10px;
  color: #7cb7ff;
  word-break: break-all;
  font-size: 15px;
}
.link-copy[data-v-d0f1e35c] {
  margin-top: 14px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.7;
  font-size: 16px;
}
.search-position-card[data-v-d0f1e35c] {
  margin-top: 18px;
}
.disabled-grid[data-v-d0f1e35c] {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}
.disabled-grid button[data-v-d0f1e35c] {
  min-height: 72px;
  padding: 14px 16px;
  border-radius: 22px;
  border: 1px dashed rgba(255, 240, 0, 0.25);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));
  color: rgba(255, 255, 255, 0.48);
  font-size: 15px;
  cursor: not-allowed;
}
.about-footer-card[data-v-d0f1e35c] {
  margin-top: 18px;
}
@media (max-width: 980px) {
.about-grid[data-v-d0f1e35c],
  .link-grid[data-v-d0f1e35c],
  .disabled-grid[data-v-d0f1e35c] {
    grid-template-columns: 1fr;
}
}
`, "",{"version":3,"sources":["webpack://./src/views/AboutView.vue"],"names":[],"mappings":";AAgIA;EACE,sCAAsC;EACtC,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;AAEA;;;;;EAKE,2CAA2C;EAC3C,mBAAmB;EACnB;;2EAEyE;EACzE;;2CAEyC;AAC3C;AAEA;EACE,kBAAkB;AACpB;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,iBAAiB;EACjB,cAAc;AAChB;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AAEA;;;;EAIE,aAAa;AACf;AAEA;EACE,SAAS;EACT,WAAW;EACX,iCAAiC;AACnC;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C;iFAC+E;EAC/E,6EAA6E;AAC/E;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC;+EAC6E;AAC/E;AAEA;;;EAGE,SAAS;AACX;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,yFAAyF;EACzF,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;AAEA;EACE,gBAAgB;AAClB;AAEA;AACE;;;IAGE,0BAA0B;AAC5B;AACF","sourcesContent":["<template>\n  <section class=\"about-page\">\n    <div class=\"about-hero\">\n      <p class=\"about-kicker\">ABOUT BV627</p>\n      <h1 class=\"about-title\">关于</h1>\n      <p class=\"about-lead\">\n        这里是 BV627 的正式关于页面，负责把普通技术栈写成横跨时代的超级基础设施，同时继续明确告诉大家：没有搜索框，搜索没用。\n      </p>\n    </div>\n\n    <div class=\"about-grid\">\n      <article class=\"about-card\">\n        <p class=\"about-label\">服务器和 CDN</p>\n        <h2 class=\"about-card-title\">云端基础设施矩阵</h2>\n        <div class=\"stack-list\">\n          <div class=\"stack-item\">\n            <h3>weidiaisi 智障云端</h3>\n            <p class=\"about-copy\">\n              云计算服务由 weidiaisi 智障云端，智慧在云端提供技术支持。\n            </p>\n            <p class=\"stack-aside\">\n              实际部署形态：其实就是普通公有云，但经过 BV627 语义包装后显得格外先进。\n            </p>\n          </div>\n          <div class=\"stack-item\">\n            <h3>weidsi 长江技术 GloBal Accrleleaion NEtaowk</h3>\n            <p class=\"about-copy\">\n              CDN 加速由 weidsi 长江技术 GloBal Accrleleaion NEtaowk 提供服务。\n            </p>\n            <p class=\"stack-aside\">\n              实际网络模型：其实就是普通 CDN，只不过命名已经先把气势拉满。\n            </p>\n          </div>\n        </div>\n      </article>\n\n      <article class=\"about-card\">\n        <p class=\"about-label\">运维和网站框架</p>\n        <h2 class=\"about-card-title\">跨时代运行环境</h2>\n        <div class=\"stack-list\">\n          <div class=\"stack-item\">\n            <h3>鸿蒙系统信创操作环境</h3>\n            <p class=\"about-copy\">\n              服务器面板使用鸿蒙系统信创操作环境，以确保整个运维门面既现代又有一种难以描述的庄严感。\n            </p>\n          </div>\n          <div class=\"stack-item\">\n            <h3>JAVASCRIPT 动态注入形式</h3>\n            <p class=\"about-copy\">\n              网站框架基于跨时代 JAVASCRIPT 动态注入形式构建。\n            </p>\n            <p class=\"stack-aside\">\n              翻译成人话：就是网页在跑 JavaScript，但 BV627 必须把这件事说成一种新的纪元。\n            </p>\n          </div>\n        </div>\n      </article>\n    </div>\n\n    <section class=\"about-links-card\">\n      <div class=\"showcase-head\">\n        <p class=\"about-label\">相关链接</p>\n        <h2 class=\"about-card-title\">官方合作入口</h2>\n      </div>\n      <div class=\"link-grid\">\n        <a\n          class=\"link-card\"\n          href=\"https://lttstore.com/\"\n          target=\"_blank\"\n          rel=\"noreferrer\"\n        >\n          <p class=\"link-label\">weidiaisi 智障云</p>\n          <p class=\"link-url\">https://lttstore.com/</p>\n          <p class=\"link-copy\">可通过此链接注册，册，会发放优惠券。</p>\n        </a>\n        <a\n          class=\"link-card\"\n          href=\"https://www.hydun.com\"\n          target=\"_blank\"\n          rel=\"noreferrer\"\n        >\n          <p class=\"link-label\">weidsi 长江技术 GloBal Accrleleaion NEtaowk</p>\n          <p class=\"link-url\">https://www.hydun.com</p>\n          <p class=\"link-copy\">用于接入那套听起来像银河级骨干网、实际上是普通 CDN 的加速服务。</p>\n        </a>\n      </div>\n    </section>\n\n    <section class=\"about-card search-position-card\">\n      <p class=\"about-label\">搜索声明</p>\n      <h2 class=\"about-card-title\">没有搜索框</h2>\n      <p class=\"about-copy\">\n        搜索没用，所以不做搜索框。这不是遗漏，这是整个 BV627 网站体验工程里的主动设计决策。\n      </p>\n      <div class=\"about-pills\">\n        <span>不提供关键词检索</span>\n        <span>不支持站内搜</span>\n        <span>也不打算接入</span>\n      </div>\n    </section>\n\n    <section class=\"disabled-showcase\">\n      <div class=\"showcase-head\">\n        <p class=\"about-label\">不可用功能</p>\n        <h2 class=\"about-card-title\">点不动的高端功能展台</h2>\n      </div>\n      <div class=\"disabled-grid\">\n        <button type=\"button\" disabled>超级搜索</button>\n        <button type=\"button\" disabled>BV627 会员高速登入</button>\n        <button type=\"button\" disabled>室长超维后台</button>\n        <button type=\"button\" disabled>量子直播总控台</button>\n        <button type=\"button\" disabled>宇宙分发中枢</button>\n        <button type=\"button\" disabled>BV627 私密频道</button>\n        <button type=\"button\" disabled>一键申请直播间</button>\n        <button type=\"button\" disabled>高能弹幕审判台</button>\n      </div>\n    </section>\n\n    <section class=\"about-footer-card\">\n      <p class=\"about-label\">附加说明</p>\n      <p class=\"about-copy\">\n        本页面继续坚持 BV627 世界观：功能可以很多，能不能用是另一回事；样式必须高端，交互可以原地冻结。\n      </p>\n    </section>\n  </section>\n</template>\n\n<style scoped>\n.about-page {\n  width: min(1280px, calc(100vw - 28px));\n  margin: 0 auto;\n  padding: 28px 0 56px;\n  color: #f7f1e8;\n}\n\n.about-hero,\n.about-card,\n.about-links-card,\n.disabled-showcase,\n.about-footer-card {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 32px;\n  background:\n    radial-gradient(circle at top left, rgba(255, 240, 0, 0.12), transparent 24%),\n    linear-gradient(150deg, rgba(24, 18, 10, 0.96), rgba(10, 11, 16, 0.96));\n  box-shadow:\n    0 24px 60px rgba(0, 0, 0, 0.36),\n    inset 0 1px 0 rgba(255, 255, 255, 0.06);\n}\n\n.about-hero {\n  padding: 34px 32px;\n}\n\n.about-kicker,\n.about-label {\n  margin: 0 0 10px;\n  color: #fff000;\n  font-size: 12px;\n  letter-spacing: 4px;\n  text-transform: uppercase;\n}\n\n.about-title {\n  margin: 0;\n  font-size: clamp(48px, 10vw, 96px);\n  line-height: 0.92;\n  color: #fffdf7;\n}\n\n.about-lead,\n.about-copy {\n  margin: 14px 0 0;\n  max-width: 860px;\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 19px;\n  line-height: 1.7;\n}\n\n.about-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n  margin-top: 18px;\n}\n\n.about-card,\n.about-links-card,\n.disabled-showcase,\n.about-footer-card {\n  padding: 28px;\n}\n\n.about-card-title {\n  margin: 0;\n  color: #fff;\n  font-size: clamp(28px, 4vw, 44px);\n}\n\n.stack-list {\n  display: grid;\n  gap: 18px;\n  margin-top: 18px;\n}\n\n.stack-item {\n  padding: 18px 20px;\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.stack-item h3 {\n  margin: 0;\n  color: #fffdf8;\n  font-size: 24px;\n  line-height: 1.2;\n}\n\n.stack-item .about-copy {\n  margin-top: 10px;\n}\n\n.stack-aside {\n  margin: 10px 0 0;\n  color: rgba(255, 240, 0, 0.82);\n  font-size: 15px;\n  line-height: 1.7;\n}\n\n.about-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 18px;\n}\n\n.about-pills span {\n  padding: 10px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.06);\n  color: #f6f1e8;\n  font-size: 14px;\n}\n\n.disabled-showcase {\n  margin-top: 18px;\n}\n\n.about-links-card {\n  margin-top: 18px;\n}\n\n.showcase-head {\n  margin-bottom: 18px;\n}\n\n.link-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.link-card {\n  min-height: 180px;\n  padding: 22px;\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));\n  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;\n}\n\n.link-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(255, 240, 0, 0.24);\n  background:\n    linear-gradient(180deg, rgba(255, 240, 0, 0.08), rgba(255, 255, 255, 0.03));\n}\n\n.link-label,\n.link-url,\n.link-copy {\n  margin: 0;\n}\n\n.link-label {\n  color: #fff;\n  font-size: 22px;\n  line-height: 1.4;\n}\n\n.link-url {\n  margin-top: 10px;\n  color: #7cb7ff;\n  word-break: break-all;\n  font-size: 15px;\n}\n\n.link-copy {\n  margin-top: 14px;\n  color: rgba(255, 255, 255, 0.78);\n  line-height: 1.7;\n  font-size: 16px;\n}\n\n.search-position-card {\n  margin-top: 18px;\n}\n\n.disabled-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.disabled-grid button {\n  min-height: 72px;\n  padding: 14px 16px;\n  border-radius: 22px;\n  border: 1px dashed rgba(255, 240, 0, 0.25);\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));\n  color: rgba(255, 255, 255, 0.48);\n  font-size: 15px;\n  cursor: not-allowed;\n}\n\n.about-footer-card {\n  margin-top: 18px;\n}\n\n@media (max-width: 980px) {\n  .about-grid,\n  .link-grid,\n  .disabled-grid {\n    grid-template-columns: 1fr;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
